export default "__VITE_ASSET__BCosQb8K__"